import React from "react";
import "./Loader.css";
import logo from "../../assets/menty-tours-logo.png";

export default function Loader() {
  return (
    <div className="loader light">
      <div className="loader-content">
        <div className="wave-spinner">
          <img src={logo} alt="Menty Tours" className="loader-logo" />
        </div>
        <p className="loader-text">Loading your journey......</p>
      </div>
    </div>
  );
}
